import { useNavigate } from "react-router-dom";
import { UserContext } from "../../App";
import { useEffect, useState, useContext } from "react";
import moment from "moment";
import Select from "react-select";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Notes.css";
import menuLookup from "../../assets/images/menuLookup.svg";

function Notes(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const user = useContext(UserContext);
  const accountOptions = [];
  const [selectedAccountWashTypeIds, setSelectedAccountWashTypeIds] =
    useState("");
  const [accountId, setAccountId] = useState("");
  const [accountLocationNumber, setAccountLocationNumber] = useState(0);
  const [washtypeId, setWashtypeId] = useState("");
  const [washtypeName, setWashtypeName] = useState("");
  const [accountSummary, setAccountSummary] = useState([]);
  const [selectedAccountWashTypes, setSelectedAccountWashTypes] = useState([]);
  const [washTypes, setWashTypes] = useState([]);
  const [vehicleNumberList, setVehicleNumberList] = useState([]);
  const [filteredVehicleNumberList, setFilteredVehicleNumberList] = useState(
    [],
  );
  const [fleetList, setFleetList] = useState([]);
  const [hasUnitOfMeasurement, setHasUnitOfMeasurement] = useState(false);
  const [unitOfMeasurement, setUnitOfMeasurement] = useState("");
  const [filterdWashList, setFilterdWashList] = useState([]);
  const [washInventoryList, setWashInventoryList] = useState([]);
  const [selectedFleet, setSelectedFleet] = useState({});
  const [note, setNote] = useState("");

  function filterWashTypeInfo() {
    let newList = [];
    if (selectedAccountWashTypeIds) {
      washTypes.forEach((item, index) => {
        if (selectedAccountWashTypeIds.includes(item.id)) {
          newList.push(item);
        }
      });
      setSelectedAccountWashTypes(newList);
    } else {
      setSelectedAccountWashTypes(washTypes);
    }
  }

  const handleSelectChange = (newValue) => {
    setSelectedFleet(newValue);
  };

  function filterFleetInfo() {
    let newList = [];
    vehicleNumberList.forEach((item, index) => {
      if (
        item.accountId === Number(accountId) &&
        item.washTypeId === Number(washtypeId) &&
        item.locationNumber === Number(accountLocationNumber)
      ) {
        newList.push(item);
      }
    });
    setFilteredVehicleNumberList(newList);
  }

  function getFleetList() {
    let newList = [];
    filteredVehicleNumberList.map((obj, index) => {
      newList.push({
        value: obj.id,
        label: obj.vehicleNumber.trim().toUpperCase(),
      });
    });
    return newList;
  }

  function cleanVehicleNumbers(array) {
    const uniqueNumbers = new Set();
    return array
      .map((vehicle) => {
        if (vehicle && vehicle.label) {
          const cleanLabel = vehicle.label.replace(/\s/g, "");
          if (!uniqueNumbers.has(cleanLabel)) {
            uniqueNumbers.add(cleanLabel);
            return { value: vehicle.value, label: cleanLabel };
          }
        }
        return null;
      })
      .filter(Boolean);
  }

  function getNotesData() {
    let notesData = {
      accountId: parseInt(accountId),
      leadId: user["id"] ?? "",
      locationNumber: parseInt(accountLocationNumber),
      note: note,
      washInventoryId: selectedFleet.value,
      noteDate: moment().utc().format(),
    };
    return notesData;
  }

  function clearWashList() {
    setWashtypeId("");
    setFleetList([]);
    setSelectedFleet({});
    setNote("");
  }

  useEffect(() => {
    props.setTab("notes");
    setAccountSummary(props.accountSummary);
    setWashTypes(props.washTypes);
    setWashInventoryList(props.washInventoryList);
  }, [props]);

  useEffect(() => {
    accountSummary.forEach((account) => {
      account.locations.forEach((location) => {
        let option = {
          value:
            account.accountId +
            "#~#" +
            account.name +
            "#~#" +
            location.locationNumber,
          label:
            account.name +
            (account.locations.length > 1 ? " - " + location.name : ""),
          washtypeIds: location.washTypeIds,
        };
        accountOptions.push(option);
      });
    });
  });

  useEffect(() => {
    if (
      accountId &&
      accountSummary.length > 0 &&
      selectedAccountWashTypes.length > 0
    ) {
      const accountItem = accountSummary.find(
        (item) => item.accountId === Number(accountId),
      );
      const accountLocation = accountItem
        ? accountItem.locations.find(
            (item) => item.locationNumber === Number(accountLocationNumber),
          )
        : undefined;

      if (accountLocation && accountLocation.washTypeIds.length > 0) {
        const IDS = accountLocation.washTypeIds;
        const filteredWashes = selectedAccountWashTypes.filter((item) =>
          IDS.includes(item.id),
        );
        setFilterdWashList(filteredWashes);
      } else {
        setFilterdWashList([]);
      }
    }
  }, [
    accountId,
    accountLocationNumber,
    accountSummary,
    selectedAccountWashTypes,
  ]);

  useEffect(() => {
    setWashtypeId("");
    if (accountId !== "") {
      filterWashTypeInfo();
    }
  }, [accountId, accountLocationNumber]);

  useEffect(() => {
    setSelectedFleet({});
    if (accountId !== "" && washtypeId !== "") {
      filterFleetInfo();
    }
  }, [accountId, washtypeId, accountLocationNumber]);

  useEffect(() => {
    setVehicleNumberList(washInventoryList);
  }, [washInventoryList]);

  useEffect(() => {
    setFleetList(cleanVehicleNumbers(getFleetList()));
  }, [filteredVehicleNumberList]);

  return (
    <Col className="form-container">
      <Row className="head-label">
        <Col xs={8} style={{ padding: "unset" }}>
          {t("addNotes.label")}
        </Col>
        <Col className="menu-position-right item-padding" xs={4}>
          <img
            src={menuLookup}
            alt={"menu-icon"}
            style={{ padding: "10px 0px" }}
            onClick={() => navigate("/list-notes")}
          />
        </Col>
      </Row>

      <Row className="form-align-center" style={{ marginTop: "10px" }}>
        <Form.Group as={Col} className="mb-3" controlId="formPlaintextAccount">
          <Row>
            <Form.Label column sm="6">
              {t("account.label")}
            </Form.Label>
          </Row>
          <Row>
            <Col sm="12">
              <Select
                options={accountOptions}
                onChange={(e) => {
                  let data = e.value.split("#~#");
                  setSelectedAccountWashTypeIds(e.washtypeIds);
                  setAccountId(data[0]);
                  setAccountLocationNumber(data[2]);
                }}
              />
            </Col>
          </Row>
        </Form.Group>
      </Row>

      <Row className="form-align-center">
        <Form.Group as={Col} className="mb-3" controlId="formPlaintextWashtype">
          <Row>
            <Form.Label column sm="6">
              {t("washtype.label")}
            </Form.Label>
          </Row>
          <Row>
            <Col sm="12">
              <Form.Select
                className="custom-width"
                value={
                  washtypeId + "#~#" + washtypeName + "#~#" + unitOfMeasurement
                }
                disabled={false}
                onChange={(e) => {
                  let data = e.target.value.split("#~#");
                  setWashtypeId(data[0]);
                  setWashtypeName(data[1]);
                  setUnitOfMeasurement(data[2]);
                  if (data[2] === "quantity") {
                    setHasUnitOfMeasurement(false);
                  } else {
                    setHasUnitOfMeasurement(true);
                  }
                }}
              >
                <option value="">Select</option>
                {filterdWashList.map((obj) => {
                  return (
                    <option
                      key={obj.id}
                      value={
                        obj.id +
                        "#~#" +
                        obj.name +
                        "#~#" +
                        obj.unitOfMeasurement
                      }
                    >
                      {obj.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Col>
          </Row>
        </Form.Group>
      </Row>

      <Row
        className="form-align-center"
        style={{ display: hasUnitOfMeasurement ? "none" : "block" }}
      >
        <Form.Group
          as={Col}
          className="mb-3"
          controlId="formPlaintextVehicleNumber"
        >
          <Row>
            <Form.Label column sm="4">
              {t("vehicleNumber.label")}
            </Form.Label>
          </Row>
          <Row>
            <Col sm="12">
              <Select
                onChange={handleSelectChange}
                options={fleetList}
                value={selectedFleet}
              />
            </Col>
          </Row>
        </Form.Group>
      </Row>

      <Row className="form-align-center">
        <Form.Group as={Col} className="mb-3" controlId="formPlaintextNotes">
          <Row>
            <Form.Label column sm="4">
              {t("notes.label")}
            </Form.Label>
          </Row>
          <Row>
            <Col sm="12">
              <Form.Control
                as="textarea"
                rows={3}
                value={note}
                onChange={(e) => {
                  setNote(e.target.value);
                }}
              />
            </Col>
          </Row>
        </Form.Group>
      </Row>

      <Row className="form-align-center" style={{ padding: "1px 10px" }}>
        <Button
          className="login-btn"
          style={{ margin: "auto" }}
          disabled={!(accountId && note)}
          onClick={async (e) => {
            e.preventDefault();
            props.onSave(getNotesData());
            setAccountId(accountId);
            clearWashList();
          }}
        >
          <label className="login-btn-label">{t("save.label")}</label>
        </Button>
      </Row>
    </Col>
  );
}

export default Notes;
